<template>
  <component :is="currentComponent" callerComp="adminProfileViewer"></component>
</template>
<script>
import { mapGetters} from "vuex";
import Vue from 'vue'
export default {
    data () {
      return {
        currentComponent: null,
        adminTrainerRoutes: [
          'AdminTrainersProfileAbout',
          'AdminTrainerProfileSales',
          'AdminTrainerProfilePost',
          'AdminTrainerProfileVod',
          'AdminTrainerProfileIntegrations'
        ]
      }
    },
    computed: {
      ...mapGetters([
        "adminUsersTrainers",
        "adminUsersAttendee"
      ]),
    },
    created () {
      const roleId = this.$route.params.id
      if (this.adminTrainerRoutes.includes(this.$route.name) && roleId) {
        this.$store.dispatch('getAdminUsersTrainers', {userId: roleId})
      } else if (this.$route.name === 'AdminUsersProfileAbout' && roleId) {
        this.$store.dispatch('getAdminUsersAttendee', {userId: roleId})
      }
    },
    watch: {
      async adminUsersTrainers (data) {
        this.$store.commit('setTrainerProfile', data)
        Vue.component('TrainerProfilePage', await this.getTrainerRenderComponent());
        this.currentComponent = 'TrainerProfilePage'
      },
      async adminUsersAttendee (data) {
        this.$store.commit('setUserProfile', data)
        Vue.component('UserProfilePage', await this.getUserRenderComponent());
        this.currentComponent = 'UserProfilePage'
      }
    },
    methods: {
      getTrainerRenderComponent () {
        return import('@/views/trainer/profile/TrainerProfile.vue').then((component) => {
          return component.default
        })
      },
      getUserRenderComponent () {
        return import('@/views/user/profile/UserProfile.vue').then((component) => {
          return component.default
        })
      }
    }
}
</script>
<style>
</style>
